import { render, staticRenderFns } from "./DealerForm.vue?vue&type=template&id=417f25f4&scoped=true"
import script from "./DealerForm.vue?vue&type=script&lang=ts"
export * from "./DealerForm.vue?vue&type=script&lang=ts"
import style0 from "./DealerForm.vue?vue&type=style&index=0&id=417f25f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417f25f4",
  null
  
)

export default component.exports